import React from 'react';
import styled from 'styled-components';

import SubtleIndicator from './SubtleIndicator';
import { Colors } from 'mineralsoft/components/common/constants';

const Svg = styled.svg`
  display: inline-block;
  position: relative;
  height: 1em;
  width: 1em;
  margin: 0;
  padding: 0;
  transform-origin: 50% 50%;
  animation: anim-loading 0.75s ease-in-out infinite;

  @keyframes anim-loading {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

interface LoadingIndicatorProps {
  contextColor?: string;
  subtle?: boolean;
  size?: string;
  style?: React.CSSProperties;
}

const options: Record<string, [string, string]> = {
  [Colors.freshLinen]: [Colors.silver, Colors.blue],
  [Colors.softFog]: [Colors.silver, Colors.blue],
  [Colors.silver]: [Colors.timberwolf, Colors.deepSpace],
  [Colors.timberwolf]: [Colors.slate, Colors.freshLinen],
  [Colors.slate]: [Colors.charcoal, Colors.freshLinen],
  [Colors.charcoal]: [Colors.slate, Colors.freshLinen],
  [Colors.deepSpace]: [Colors.charcoal, Colors.gold],
  [Colors.red]: [Colors.redDark, Colors.freshLinen],
  [Colors.redDark]: [Colors.red, Colors.freshLinen],
  [Colors.blue]: [Colors.blueDark, Colors.freshLinen],
  [Colors.blueDark]: [Colors.blue, Colors.freshLinen],
  [Colors.gold]: [Colors.goldDark, Colors.goldPale],
};

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  contextColor = Colors.blue,
  subtle = false,
  size = '16px',
  style = {},
}) => {
  const getColors = (): [string, string] =>
    options[contextColor] || [Colors.blueDark, Colors.freshLinen];

  const [backgroundColor, indicatorColor] = getColors();

  if (subtle) {
    return <SubtleIndicator size="3px" />;
  }

  return (
    <Svg
      style={{ ...style, width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      data-testid="loading"
    >
      <circle cx="8" cy="8" r="7" strokeWidth="2" stroke={backgroundColor} />
      <path
        strokeWidth="2"
        strokeLinecap="round"
        stroke={indicatorColor}
        d="M8 1C11.866 1 15 4.13401 15 8C15 9.933 14.2165 11.683 12.9497 12.9497"
      />
    </Svg>
  );
};

export default LoadingIndicator;
